import React from 'react';
import { motion } from 'framer-motion';
import { InfinityIcon, DownloadIcon, WifiOffIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const perks = [{
  icon: InfinityIcon,
  text: 'Un solo pago, acceso para siempre'
}, {
  icon: DownloadIcon,
  text: 'Descargá todo en tu celu o compu'
}, {
  icon: WifiOffIcon,
  text: 'Tejé incluso sin internet'
}];
export function Pricing() {
  return <section id="comprar" className="scroll-mt-16 bg-cream py-16 sm:py-24" aria-labelledby="price-title" data-id="element-105" data-mp="1vta0bm6rc48y">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-106" data-mp="1rthwtnw80oag">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-107" data-mp="25s7wnbafd22i">
          Precio de lanzamiento
        </span>
        <h2 id="price-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-108" data-mp="20s3dfdi4tt8l">
          Queremos que el arte del amigurumi llegue a cada rincón
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-muted" data-id="element-109" data-mp="3c93301d3htyx">
          Por eso, si te sumás hoy, no vas a pagar $27.500.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-[2rem] border-2 border-terracotta bg-white p-8 shadow-soft sm:p-12" data-id="element-110" data-mp="3vz72o2kemxs4">
          <p className="text-lg font-semibold text-muted line-through" data-id="element-111" data-mp="3d8z0bmoj4bcz">$27.500 ARS</p>
          <p className="mt-1 text-sm font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-112" data-mp="3d74hcdwtitbj">
            Hoy solo
          </p>
          <p className="mt-2 font-display text-6xl font-black leading-none text-ink sm:text-7xl" data-id="element-113" data-mp="3n6lj4k8y8n28">
            $16.990
            <span className="ml-2 align-middle text-xl font-bold text-muted" data-id="element-114" data-mp="3rywv4lgyrzb5">ARS</span>
          </p>

          <div className="stitch-divider mx-auto my-8 max-w-xs" aria-hidden="true" data-id="element-115" data-mp="2uhepnzocqnnu" />

          <ul className="mx-auto grid max-w-lg gap-3 text-left sm:grid-cols-3 sm:text-center" data-id="element-116" data-mp="2zgra6drr3in9">
            {perks.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-3 sm:flex-col sm:gap-2" data-id="element-117" data-mp="2mhruttlpjq5r">
                <Icon className="h-5 w-5 shrink-0 text-terracotta" aria-hidden="true" data-id="element-118" data-mp="2mfxkf982bgfx" />
                <span className="text-sm font-semibold text-ink" data-id="element-119" data-mp="315wizd3j4tvx">{text}</span>
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-120" data-mp="2w9xkgwohlvhs">
            <CtaButton subLabel="Compra 100% segura · Acceso inmediato por mail" data-id="element-121" data-mp="28hh36ockq7jj" />
          </div>
        </motion.div>
      </div>
    </section>;
}